export const MOBILE_TOP_BAR_HEIGHT = 56;
export const MOBILE_BOTTOM_NAV_HEIGHT = 64;
export const MOBILE_MAX_PRIMARY_TABS = 4;
